/**
 * DeckFeedSkeleton — Loading placeholder for the Deck feed page.
 * Shows header + grid of card placeholders using mb-skeleton tokens.
 */
export function DeckFeedSkeleton() {
  return (
    <div className="deck-feed-page">
      <div className="deck-background" />

      {/* Header skeleton */}
      <header style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: 'var(--mb-space-4)',
      }}>
        <div className="mb-skeleton" style={{ width: 32, height: 32, borderRadius: '50%' }} />
        <div className="mb-skeleton mb-skeleton-title" style={{ width: 80, marginBottom: 0 }} />
        <div style={{ flex: 1 }} />
        <div className="mb-skeleton" style={{ width: 100, height: 32, borderRadius: 'var(--mb-radius-md)' }} />
        <div className="mb-skeleton" style={{ width: 80, height: 32, borderRadius: 'var(--mb-radius-md)' }} />
      </header>

      {/* Card grid skeleton */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 'var(--mb-space-4)',
        padding: '0 var(--mb-space-4) var(--mb-space-4)',
        maxWidth: 1200,
        margin: '0 auto',
        width: '100%',
      }}>
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} style={{
            background: 'var(--mb-dark-2)',
            borderRadius: 'var(--mb-radius-xl)',
            border: '1px solid var(--mb-border-subtle)',
            overflow: 'hidden',
            animationDelay: `${i * 0.05}s`,
          }}>
            {/* Cover */}
            <div className="mb-skeleton" style={{ height: 100, borderRadius: 0 }} />
            {/* Identity */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px' }}>
              <div className="mb-skeleton mb-skeleton-avatar" />
              <div style={{ flex: 1 }}>
                <div className="mb-skeleton mb-skeleton-text" style={{ width: '70%' }} />
                <div className="mb-skeleton mb-skeleton-text" style={{ width: '40%', marginBottom: 0 }} />
              </div>
            </div>
            {/* Skills */}
            <div style={{ padding: '0 16px 12px', display: 'flex', flexDirection: 'column', gap: 6 }}>
              <div className="mb-skeleton mb-skeleton-text" style={{ width: '90%' }} />
              <div className="mb-skeleton mb-skeleton-text" style={{ width: '75%' }} />
              <div className="mb-skeleton mb-skeleton-text" style={{ width: '60%', marginBottom: 0 }} />
            </div>
            {/* Actions */}
            <div style={{ display: 'flex', gap: 8, padding: '8px 16px 16px' }}>
              <div className="mb-skeleton" style={{ flex: 1, height: 36, borderRadius: 'var(--mb-radius-md)' }} />
              <div className="mb-skeleton" style={{ flex: 1, height: 36, borderRadius: 'var(--mb-radius-md)' }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
